import http from './httpService';

class PromoApi {
  headers = {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json",
  };
  
  async getPromotions() {
    const result = await http.get(process.env.REACT_APP_BASE_URL + `api/promotion/list`,);
    return result;
  }

  async recordPromoRequest(data:any) {
      return http.post(process.env.REACT_APP_BASE_URL + `api/promotion`, JSON.stringify(data), {
        headers: 		{
		    accept: "application/json, text/plain, */*",
		    "content-type": "application/json",
		  },
      });
    }

}

export const promoApi = new PromoApi();
